module.exports = __webpack_public_path__ + "static/media/course_01.bfd961b0.jpg";